import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DataCodeLogo from "../../../../assets/images/datacodelogo.png";
import { useDispatch, useSelector } from 'react-redux';
import { requestQuizInviteByCandidate } from '../../actions';
import { ISODateFormate } from '../../../../utils/dateUtils';

const ReactQuizModal = ({
  args,
  label = "Request Reset",
  recipient = "Datacode Admin",
  quiz,
}) => {
  const dispatch = useDispatch();
  const { submittingInviteFormLoading } = useSelector((state) => state.quizTest);
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const handleSend = () => {
    const quizInvite = {
      status: 'requested',
      quizId: quiz._id,
      email: currentUser.email,
      user: currentUser._id,
      expDate: ISODateFormate(new Date(new Date().setDate(new Date().getDate() + 7))),
    };

    dispatch(requestQuizInviteByCandidate(quizInvite)).then((res) => {
      if (res && res.success) {
        setModal(false);
      }
      alert('Quiz reset request sent successfully.');
    }).catch(() => {
      alert('Failed to send quiz reset request.');
    });
  };

  return (
    <div>
      <div className="bg-transparent border-0" onClick={toggle}>
        {label}
      </div>

      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle} className="d-flex align-items-center">
          <img src={DataCodeLogo} alt="DataCode logo" height={40} className="me-2" />
          <div>
            <h6 className="mb-0">Request Quiz Reset</h6>
            <small className="text-muted">
              To: <strong>{recipient}</strong>
            </small>
          </div>
        </ModalHeader>

        <ModalBody>
          <p className="mb-2">
            You are requesting <strong>{recipient}</strong> to reset your quiz.
          </p>

          {quiz?.quizTitle && (
            <p className="mb-1">
              Quiz: <strong>{quiz?.quizTitle}</strong>
            </p>
          )}

          <div className="alert alert-warning py-2 mb-3">
            Resetting will clear your current attempt and allow you to retake the quiz.
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="primary" onClick={handleSend}>
            {submittingInviteFormLoading ? "Sending Request..." : "Send Request"}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ReactQuizModal;
